@import '~style-sheet-helpers/core.less';
@import (reference) '../../../constants/spacing.module.less';

.page-content {
  padding: @space-24;
  background: var(--grey-100);
  height: 100%;
  overflow: auto;
}

.banner-container {
  margin-bottom: @space-40;
}

.resources-section {
  margin-bottom: @space-40;
}

.resource-item {
  padding: @space-16;
  border: 1px solid var(--grey-300);
  align-items: center;
  background-color: var(--white);
  border-top: 0;

  &:first-child {
    border-top: 1px solid var(--grey-300);
    border-top-right-radius: @space-8;
    border-top-left-radius: @space-8;
  }

  &:last-child {
    border-bottom-right-radius: @space-8;
    border-bottom-left-radius: @space-8;
  }

  a {
    font-weight: 500;
  }
}

.resource-content {
  flex: 1;
  gap: @space-8;
}

.resource-description {
  color: var(--grey-600);
}

.process-section {
  padding: @space-40 @space-0;
}

.process-title {
  text-align: center;
  margin-bottom: @space-24;
}

.process-steps-row {
  gap: @space-32;
  width: 100%;
  margin: @space-0 auto;
  align-items: stretch;
}

.banner-message {
  text-align: center;
}

.banner-content-container {
  align-items: flex-start;
}
